const Convert = () => {
  return (
    <div className="flex">
      <iframe
        className="w-full min-h-[50vh]"
        src="https://widget.changelly.com/?from=$%7Bcoin.from%7D&to=$%7Bcoin.to%7D&amount=0.1&address=&fromDefault=btc&toDefault=eth&merchant_id=xd2xrwsdtmajne5b&payment_id=&v=3"
      ></iframe>
    </div>
  );
};

export default Convert;
